import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import ListArticle from './ListArticle';
import FormArticle from './FormArticle';
import React from 'react';

const Article = (props) => {
  const {
    match,
    match: { url },
  } = props;
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(url, 'view') && (
          <Route
            exact
            path={`${url}`}
            component={() => <ListArticle match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(url, 'add') && (
          <Route path={`${url}/add-article`} component={FormArticle} />
        )}
        {MyUtil.hasPermission(url, 'update') && (
          <Route
            path={`${url}/edit-article/:id/:lang`}
            component={FormArticle}
          />
        )}
      </Switch>
    </div>
  );
};

export default Article;
